<template>
  <div class="modal-content">

    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">{{ model.title }}</h4>
    </div>

    <div class="modal-body">
      <div>
        <h2 style="display: inline-block">Le véhicule est-il une 1er main ?</h2>
        <input style="display: inline-block;margin-left: 31%" type="radio" id="onePickeddHand" value="oui" v-model="pickedHand">
        <label for="onePickeddHand">oui</label>
        <input style="margin-left: 5%;" type="radio" id="twoPickedHand" value="non" v-model="pickedHand">
        <label for="twoPickedHand">non</label>
        <br>
      </div>

      <div>
        <h2 style="display: inline-block"> Le véhicule est-il pour un usage professionnel ?</h2>
        <input style="display: inline-block;margin-left: 11%" type="radio" id="onePickedPro" value="oui" v-model="pickedPro">
        <label for="onePickedPro">oui</label>
        <input style="margin-left: 5%;" type="radio" id="twoPickedPro" value="non" v-model="pickedPro">
        <label for="twoPickedPro">non</label>
        <br>
      </div>
    </div>

    <p v-if="this.error" style="color: red; margin-left: 30%"> Veuillez cocher toutes les cases afin de validé.</p>

    <div class="modal-footer justify-content-center">
      <button type="button"
              class="btn btn-default"
              @click="closeModal">Annuler</button>
      <button type="button"
              class="btn btn-danger"
              @click="onConfirm">Oui, confirmer</button>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'

  export default {
    data: () => ({
      store,
      pickedHand: '',
      pickedPro: '',
      error: false,
    }),

    computed: {
      model () {
        return store.modal.dataModel
      },
      formIsCompleted () {
        if (this.pickedPro === '' || this.pickedHand === '') {
          return false
        }
        return true
      },
    },

    methods: {
      onConfirm () {
        if (this.formIsCompleted) {
          this.$bus.$emit(`purchase-order-success`, {'answerHand': this.pickedHand, 'answerPro': this.pickedPro})
          this.closeModal();
        } else {
          this.error = true
        }
      }
    }
  }
</script>
